import { Navigate } from 'react-router-dom';
import { useSelector } from 'src/store/Store';
import { getRoleHomePath } from 'src/utils/roles';

interface PrivateRouteProps {
  children: JSX.Element;
  allowedRoles?: string[];
}

const PrivateRoute = ({ children, allowedRoles }: PrivateRouteProps) => {
  const { accessToken, role } = useSelector((state) => state.auth);

  if (!accessToken) return <Navigate to="/auth/login" replace />;

  if (allowedRoles && (!role || !allowedRoles.includes(role))) {
    return <Navigate to={getRoleHomePath(role)} replace />;
  }

  return children;
};

export default PrivateRoute;